import React, { useState, useEffect, useRef } from "react";
import ResourcesTab from "../ResourcesTab";
import { staticURLs } from "../../../config/urls";
import MedicalIDFraudProtectionForm from "../../Dialogs/MedicalIdFraudProtectionForm";
import { DialogComponent } from "../../common/DialogComponent";
import FraudAlertRemainder from "./FraudAlertRemainder";
import { notification } from "antd";
import * as services from "../../../store/service";
import FraudAlertReminderDialog from "../../Dialogs/FraudAlertReminderDialog";
import { ezsServiceIds, idfServiceIds } from "../../../config/UserServicesList";
import { useAreServicesActive } from "../../../util/CommonServices";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { sendRequest } from "../../../util/httpClient";

const Forms = () => {
    const dispatch = useDispatch();
    const [showDialog, setShowDialog] = useState(false);
    const isFraudAlertRemainderActive = useAreServicesActive([idfServiceIds.fraudAlertReminder, ezsServiceIds.fraudAlertReminder]);
    const isMedicalIDFraudProtectionFormActive = useAreServicesActive([idfServiceIds.medicalIDFraudProtection, ezsServiceIds.medicalIdFraudProtection]);
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const handleClick = () => {
        setShowDialog(true);
        window.addToDataLayer({ event: "Medical ID Fraud Protection" });
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [showFraudAlertDialog, setShowFraudAlertDialog] = useState(false);
    const [state, setState] = useState({ reminderDate: "", showSetReminderBtn: false });

    const openNotification = (type: any, desc: string, duration: number = 5): any => {
        (notification as any)[type]({
            message: "Fraud Alert Reminder",
            description: desc,
            placement: "bottomLeft",
            className: "ant-notification-bottomLeft",
            duration: duration,
        });
    };

    const handleStateChange = (reminderDate: string, showSetReminderBtn: boolean): any => {
        setState({
            reminderDate: reminderDate,
            showSetReminderBtn: showSetReminderBtn,
        });
    };

    const setFraudAlertHandleClick = () => {
        window.addToDataLayer({ event: "Set a Fraud Alert Reminder" });
        setShowFraudAlertDialog(true);
    };

    const handleCloseFraudDialog = (): any => {
        setShowFraudAlertDialog(false);
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return sendRequest("POST", url, data, {}, true);
    };

    const getFraudAlertReminder = (): void => {
        services.getFraudAlertReminder().then((response) => {
            if (response.statusCode && response.statusCode === "200") {
                if (response.data && response.data.reminderDate) {
                    handleStateChange(response.data.reminderDate, false);
                } else {
                    handleStateChange("", false);
                }
            } else {
                handleStateChange("", false);
            }
        });
    };

    const formatDate = (date: string): string => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        const dateObj = new Date(date.split(" ")[0].replace(/-/g, "/"));
        return dateObj.toLocaleDateString([], options);
    };

    useEffect(() => {
        getFraudAlertReminder();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const handleCloseDialog = (): any => {
        setShowDialog(false);
        gotoMedicalIdFraudProtection();
    };

    const downloadDocRef = useRef<HTMLDivElement>(null);

    const gotoMedicalIdFraudProtection = () => {
        if (downloadDocRef !== null && downloadDocRef.current !== null) {
            downloadDocRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="resources-forms-page" tabIndex={-1}>
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="7" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="file-alt" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">Forms</h2>
                                </div>
                            </div>
                            <div className="box-actions"></div>
                        </div>
                        <div className="box-content">
                            {isFraudAlertRemainderActive && (
                                <FraudAlertRemainder reminderDate={state.reminderDate} formatDate={formatDate} handleClick={setFraudAlertHandleClick} />
                            )}

                            <h3 className="content-title">{tLang("resourcesSection.form.label.aboutIdentityTheft")}</h3>
                            <p>This packet conveniently compiles a list of identity theft-related forms, FAQs, and action items for easy download.</p>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.protectingIdentity}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="resource-link"
                                    onClick={() => window.addToDataLayer({ event: "Protecting your Identity" })}
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-word"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.protectingyouridentity")}</span>
                                        <span className="resource-description">MS Word</span>
                                    </span>
                                </a>
                            </div>

                            <h3 className="content-title">{tLang("resourcesSection.form.label.sampleLettersandComplaint")}</h3>
                            <p>
                                To protect your Identity, it's useful to remove your information from marketing lists sold by credit bureaus. We've provided
                                templates for these requests below as well as some templates for general complaint letters.
                            </p>

                            <div className="resource-container" ref={downloadDocRef}>
                                <a
                                    href={staticURLs.lettersEquifax}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="resource-link"
                                    onClick={() => window.addToDataLayer({ event: "Letters to Equifax" })}
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-word"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.letterstoEquifax")}</span>
                                        <span className="resource-description">Please remove my information from your marketing lists.</span>
                                    </span>
                                </a>
                            </div>
                            <div className="resource-container">
                                <a
                                    href={staticURLs.lettersToExperian}
                                    target="_blank"
                                    className="resource-link"
                                    onClick={() => window.addToDataLayer({ event: "Letters to Experian" })}
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-word"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.letterstoExperian")}</span>
                                        <span className="resource-description">Please remove my information from your marketing lists.</span>
                                    </span>
                                </a>
                            </div>
                            <div className="resource-container">
                                <a
                                    href={staticURLs.letterToCreditBureau}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="resource-link"
                                    onClick={() => window.addToDataLayer({ event: "Letter to Credit Bureaus" })}
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-word"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.letterstoCreditBureau")}</span>
                                        <span className="resource-description">Resolve a Credit Dispute.</span>
                                    </span>
                                </a>
                            </div>
                            <div className="resource-container">
                                <a
                                    href={staticURLs.generalComplaintLetter}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "General Complaint Letter" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-word"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.generalComplaintLetter")}</span>
                                        <span className="resource-description">(Product or Service)</span>
                                    </span>
                                </a>
                            </div>
                            <div className="resource-container">
                                <a
                                    href={staticURLs.generalComplaintMail}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "General Complaint Email" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-word"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.generalComplaintEmail")}</span>
                                        <span className="resource-description">(Product or Service)</span>
                                    </span>
                                </a>
                            </div>
                            {isMedicalIDFraudProtectionFormActive && (
                                <div className="resource-container">
                                    <a href="javascript:void(0)" className="resource-link" onClick={handleClick}>
                                        <span className="resource-icon">
                                            <em className="lar la-file-pdf"></em>
                                        </span>
                                        <span className="resource-text">
                                            <span className="resource-title">{tLang("resourcesSection.form.label.medicalIDFraudProtection")}</span>
                                            <span className="resource-description">Review your medical benefit statements</span>
                                        </span>
                                    </a>
                                </div>
                            )}
                            <h3 className="content-title">{tLang("resourcesSection.form.label.consumerActionHandbook")}</h3>
                            <p>
                                This compilation of essential consumer information published by the United States General Services Administration offers practical
                                advice about employment, investment, housing and your consumer rights.{" "}
                            </p>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.consumerActionHandbook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "The Complete 2017 Consumer Action Handbook" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.complete2017ConsumerActionHandbook")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.automotiveDisputeResolutionResources}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Automotive Dispute Resolution Resources" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.automotiveDisputeResolutionResources")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.betterBusinessBureau}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Better Business Bureau" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.betterBusinessBureau")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.consumerProtection}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Consumer protection and advocacy organizations" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.consumerprotection")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.quickConsumerTips}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Quick Consumer Tips" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.quickConsumerTips")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.corporateConsumerContact}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Corporate Consumer Contacts" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.corporateConsumerContacts")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.federalAgencyContacts}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Federal Agency Contacts" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.federalAgencyContacts")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.sampleComplaintLetter}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Sample Complaint Letter" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.sampleComplaintLetter")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.consumerProtectionOffices}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "State, County, and City Consumer Protection Offices" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.consumerProtectionOffices")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.tradeProfessionalAssociations}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Trade and Professional Associations" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.tradeandProfessionalAssociations")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            <h3 className="content-title">{tLang("resourcesSection.form.label.consumerActionWebsite")}</h3>
                            <p>
                                The United States General Services Administration offers continuously updated consumer information on its website. Don't miss these
                                important links:
                            </p>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.consumerActionWebsite}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "Consumer Action Website" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-link"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.consumerActionWebsite")}</span>
                                    </span>
                                </a>
                            </div>

                            <div className="resource-container">
                                <a
                                    href={staticURLs.howFileComplaint}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => window.addToDataLayer({ event: "How to File a Complaint" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-link"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.form.label.howtoFileaComplaint")}</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showDialog && (
                <DialogComponent dialogId="medical-fraud-protection-form-dialog" title="Medical fraud protection" closeDialog={handleCloseDialog}>
                    <MedicalIDFraudProtectionForm closeDialog={handleCloseDialog}></MedicalIDFraudProtectionForm>
                </DialogComponent>
            )}

            {showFraudAlertDialog && (
                <DialogComponent dialogId="dialog-set-fraud-alert-reminder" title="Fraud Alert Reminder" closeDialog={handleCloseFraudDialog}>
                    <FraudAlertReminderDialog
                        {...state}
                        callAPI={callAPI}
                        formatDate={formatDate}
                        openNotification={openNotification}
                        handleStateChange={handleStateChange}
                    ></FraudAlertReminderDialog>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default Forms;
